import {
	ApiPaginatedResponse,
	Relation,
	Translations,
	UUID,
} from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { AttributeValue } from './AttributeValueApi';
import { Component } from './ComponentApi';
import { Article } from './ArticleApi';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum QuantityConfigType {
	PROJECT = 'PROJECT',
	ROLLER_BOX_SEGMENT = 'ROLLER_BOX_SEGMENT',
	MOSQUITO_NET_SEGMENT = 'MOSQUITO_NET_SEGMENT',
}

export enum QuantityConfigCondition {
	AE_TO_AE = 'AE_TO_AE',
	AE_TO_AC = 'AE_TO_AC',
	AE_TO_AC_WIDE = 'AE_TO_AC_WIDE',
	AC_THIN_TO_AC_THIN = 'AC_THIN_TO_AC_THIN',
	AC_THIN_TO_AC_WIDE = 'AC_THIN_TO_AC_WIDE',
	AC_WIDE_TO_AC_WIDE = 'AC_WIDE_TO_AC_WIDE',
	AC_TO_MOSQUITO_NET_EDGE = 'AC_TO_MOSQUITO_NET_EDGE',
	AE_TO_MOSQUITO_NET_EDGE = 'AE_TO_MOSQUITO_NET_EDGE',
	AC_THIN_TO_MOSQUITO_NET_EDGE = 'AC_THIN_TO_MOSQUITO_NET_EDGE',
	AC_WIDE_TO_MOSQUITO_NET_EDGE = 'AC_WIDE_TO_MOSQUITO_NET_EDGE',
	MOSQUITO_NET_EDGE_TO_MOSQUITO_NET_EDGE = 'MOSQUITO_NET_EDGE_TO_MOSQUITO_NET_EDGE',
	ROLLER_BOX_HEIGHT = 'ROLLER_BOX_HEIGHT',
}

export interface QuantityConfig {
	type: QuantityConfigType;
	condition: QuantityConfigCondition | null;
	conditionValue?: string | number;
	formula: string;
}

export interface ComponentVariationArticle extends BaseEntity {
	article: Article;
	articleId: UUID;
	componentVariation?: ComponentVariation;
	componentVariationId: UUID;
	quantityConfigs: QuantityConfig[];
}

export interface ComponentVariation extends BaseEntity {
	name: string;
	component?: Component;
	componentId: UUID;
	attributeValues: AttributeValue[];
	componentVariationArticles: ComponentVariationArticle[];
	relations: Relation[];
	translations: Translations<{
		name: string;
	}>;
}

class ComponentVariationApi extends EntityApi<ComponentVariation> {
	constructor() {
		super(QueryKey.componentVariations);
		this.getVariationsForComponentId =
			this.getVariationsForComponentId.bind(this);
	}

	async getVariationsForComponentId(componentId: UUID) {
		const response = await httpClient.get<
			ApiPaginatedResponse<ComponentVariation>
		>(this.queryKey, {
			params: {
				'filter.component.id': componentId,
				limit: -1,
			},
		});

		return response.data.data;
	}
}

export default new ComponentVariationApi();
